import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/viktorai.webp';
import screenshot_target from '../../../images/letterfunnel/kristianschmidt.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Kristian Schmidt"
      firstname="Kristian"
      companyname="VIKTOR.ai"
      competition="Streamlit en Anvil"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/kristianschmidt.js